import { useParams } from "react-router-dom";
import "./ForgottenPassword.scss";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { resetPassword } from "../../services/auth";
export default function ForgottenPassword() {
  const { token } = useParams();
  const { t } = useTranslation();
  const [newPassword, setNewPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [matchPassword, setMatchPassword] = useState(true);
  const [tokenError, setTokenError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newPassword === repeatPassword) {
      setMatchPassword(true);
      resetPassword(token, newPassword).then((res) => {
        if (res.status === 400) {
          setTokenError("error");
        } else {
          setTokenError("no-error");
        }
      });
    } else {
      setMatchPassword(false);
      setTokenError("");
    }
  };

  return (
    <div className="forgotten-password-page">
      <div className="login-popup">
        <div className="image">
          <img
            src="https://alexfish-static.s3.eu-north-1.amazonaws.com/login_sushi.svg"
            alt="Суши"
          />
        </div>
        {tokenError === "" || tokenError === "error" ? (
          <form className="form" onSubmit={handleSubmit}>
            <div className="title">
              <p>{t("forgotten")}</p>
            </div>
            <div className="input-fields">
              <div className="password">
                <input
                  required
                  type="password"
                  placeholder={`${t("password")}`}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </div>
              <div className={"password"}>
                <input
                  required
                  type="password"
                  placeholder={`${t("repeat-password")}`}
                  value={repeatPassword}
                  onChange={(e) => setRepeatPassword(e.target.value)}
                />
              </div>
              {!matchPassword && (
                <p style={{ color: "red", fontSize: "12px" }}>
                  Паролите не съвпадат
                </p>
              )}
              {tokenError === "error" && (
                <p style={{ color: "red", fontSize: "12px" }}>
                  Невалиден или изтекъл токен
                </p>
              )}
            </div>
            <div className="buttons">
              <div className="login-button">
                <button type="submit">{t("save")}</button>
              </div>
            </div>
          </form>
        ) : (
          <div className="form">
            <h2 className="title">Паролата бе сменена успешно!</h2>
          </div>
        )}
      </div>
    </div>
  );
}
